import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import AppTooltip from '../../shared/AppTooltip';
import styles from './InfoIcon.module.scss';

const InfoIcon = ({ children, size = '12px', className = '' }) => {
  const [uniqueId] = useState(() => uuidv4());

  return (
    <React.Fragment>
      <span
        className={`material-symbols-outlined ${styles.icon} ${className}`}
        data-tip
        data-for={`info-icon-tooltip-${uniqueId}`}
        style={{
          fontSize: size,
        }}
      >
        info_i
      </span>
      <AppTooltip
        id={`info-icon-tooltip-${uniqueId}`}
        event="click"
        type="light"
        borderColor="#cecece"
        arrowColor="#fff"
      >
        {children}
      </AppTooltip>
    </React.Fragment>
  );
};

export default InfoIcon;
